module.exports = __webpack_public_path__ + "static/media/intake.e039d275.svg";